import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ProductType';
const ENDPOINT = `/product-types/`;

@Injectable({
    providedIn: 'root'
})
export class ProductTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
